import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#6ABF4B] text-white hover:bg-[#5aaa3d] shadow-md hover:shadow-lg focus:ring-[#6ABF4B]',
    secondary: 'bg-[#5C6B60] text-white hover:bg-[#4A564D] shadow-md focus:ring-[#5C6B60]',
    outline: 'border-2 border-[#5C6B60] text-[#5C6B60] hover:bg-[#5C6B60] hover:text-white focus:ring-[#5C6B60]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm rounded-xl',
    md: 'h-11 px-6 text-base rounded-2xl',
    lg: 'h-14 px-8 text-lg rounded-3xl'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-175">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-176" />}
      {children}
    </button>;
}